import React from "react";
import { LinkButton } from "components/LinkButton";
import { Popup } from "components/popups/Popup";
import useTranslation from "utils/hooks/useTranslation";
import { SvgCommandDownload, SvgCommandDuplicate, SvgCommandEdit, SvgCommandEmail, SvgCommandReport, SvgSupprimer } from "components/svg";
import { env } from "env";

export const ProjectActionsPopup: React.FC<{
    item: any;
    onClose: () => void;
    openProject: (item: any) => void;
    duplicateProject: (item: any) => void;
    shareProject: (item: any) => string;
    shareReport: (item: any) => string;
    renameProject: (item: any) => void;
    deleteProject: (item: any) => void;
    isOwner: boolean;
}> = ({
    item,
    onClose,
    openProject,
    duplicateProject,
    shareProject,
    shareReport,
    renameProject,
    deleteProject,
    isOwner
}) => {
        const { t } = useTranslation();

        const handleAction = (action: () => void) => {
            action();
            onClose();
        };

        return (
            <Popup fixSize="small" noHeader closeOnOutsideClick>
                <group data-direction="column" data-gap="15" data-space="20">
                    <LinkButton
                        icon={<SvgCommandEdit />}
                        gap={15}
                        title={t("UPDATE")}
                        onClick={() => handleAction(() => openProject(item))}
                    />

                    {!item.data && item.versions && (
                        <LinkButton
                            icon={<SvgCommandDuplicate />}
                            gap={15}
                            title={t("RESULTS_DUPLICATE")}
                            onClick={() => handleAction(() => duplicateProject(item))}
                        />
                    )}

                    {!item.data && (
                        <LinkButton
                            icon={<SvgCommandReport />}
                            gap={15}
                            title={t("SHARE_STUDY")}
                            onClick={() => handleAction(() => { window.location.href = shareProject(item) })}
                        />
                    )}

                    {!item.data && item._synthesisPath && (
                        <>
                            <LinkButton
                                icon={<SvgCommandEmail />}
                                gap={15}
                                title={t("SHARE_BY_MAIL")}
                                onClick={() => handleAction(() => { window.location.href = shareReport(item) })}
                            />
                            <LinkButton
                                icon={<SvgCommandDownload />}
                                gap={15}
                                title={t("DOWNLOAD_SYNTHESIS")}
                                onClick={() => window.open(`${env.api_url}/upload/synthesis/${item._synthesisPath}`, '_blank')}
                            />
                        </>
                    )}

                    <LinkButton
                        icon={<SvgCommandEdit />}
                        gap={15}
                        title={t("RESULTS_RENAME")}
                        onClick={() => renameProject(item)}
                    />

                    {!item.data && isOwner && (
                        <LinkButton
                            icon={<SvgSupprimer />}
                            gap={15}
                            title={t("DELETE")}
                            onClick={() => deleteProject(item)}
                        />
                    )}
                </group>
            </Popup>
        );
    };
